import {Column, CreateDateColumn, Entity, UpdateDateColumn} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";

@Entity({orderBy: {updatedAt: 'DESC'}})
export class GameSlot extends BaseEntity {
  @Column({type: 'boolean'})
  autoSave: boolean;

  @Column({type: 'varchar', nullable: true})
  gameId?: string;

  @Column({type: 'text'})
  gameDbDump: string;

  @Column({type: 'integer'})
  seasonId: number;

  @Column({type: 'date'})
  gameDateAt: Date;

  @Column({type: 'varchar'})
  teamName: string;

  @Column({type: 'datetime'})
  @UpdateDateColumn()
  updatedAt: Date;

  @Column({type: 'datetime'})
  @CreateDateColumn()
  createdAt: Date;
}
